import React from 'react';
import { Link } from 'react-router-dom';
import AnonymousDocumentManager from '../components/document/AnonymousDocumentManager';
import { PLANS } from '../config/plans';
import './AnonymousUploadPage.css';

const BENEFITS = [
  {
    icon: '📁',
    title: 'Larger uploads',
    description: `Upload documents up to ${PLANS.free.maxAuthFileSizeMb} MB, vs the ${PLANS.free.maxAnonymousFileSizeMb} MB guest limit.`,
  },
  {
    icon: '🗂️',
    title: 'Permanent storage',
    description: 'Your documents stay available — not just for a week.',
  },
  {
    icon: '🗃️',
    title: 'Organization',
    description: 'Group documents into folders and manage everything in one place.',
  },
  {
    icon: '📊',
    title: 'Analytics',
    description: 'See who viewed your document, which pages, and for how long.',
  },
];

const AnonymousUploadPage: React.FC = () => {
  return (
    <div className="page-container">
      <div className="page-header text-center">
        <h1 className="page-title">Share a document instantly</h1>
        <p className="page-subtitle">No sign-up required</p>
      </div>

      <div className="anon-layout">
        <div className="anon-upload-col">
          <AnonymousDocumentManager showUploader={true} />
        </div>

        <div className="anon-benefits-col">
          <p className="benefits-heading">Get more with a free account</p>
          <div className="benefits-list">
            {BENEFITS.map(b => (
              <div key={b.title} className="benefit-item">
                <span className="benefit-icon">{b.icon}</span>
                <div>
                  <strong className="benefit-title">{b.title}</strong>
                  <p className="benefit-desc">{b.description}</p>
                </div>
              </div>
            ))}
          </div>
          <Link to="/register" className="btn btn-primary w-100">Create free account</Link>
          <p className="anon-signin">Already have one? <Link to="/login">Sign in</Link></p>
        </div>
      </div>
    </div>
  );
};

export default AnonymousUploadPage;
